import { featureFlagsApiRef, useApi } from '@backstage/frontend-plugin-api';
import { Container, Header } from '@backstage/ui';
import { EmptyState } from '../empty-state';

export const LensPage = () => {
  const lensEnabled = useApi(featureFlagsApiRef).isActive('lens');

  if (!lensEnabled) {
    return (
      <EmptyState
        title="Lens Disabled"
        description="The Lens feature is currently disabled."
      />
    );
  }

  return (
    <>
      <Header
        title="Insights"
        description="Turn metrics and logs into actionable insight."
      />
      <Container>Lens ~ Observe. Understand. Improve. Repeat.</Container>
    </>
  );
};
